import { useCallback, useEffect, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { getVideo } from '../../../../s3Func/s3Download';
import MediaService from '../../../../services/MediaService';

import pauseButton from '../assets/image/pause_circle_icon@3x.png';

import './SingVideoPlayer.scss';

const SingVideoPlayer = ({ video, onRecordClick, onDemoEnded }) => {
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  const [videoSrc, setVideoSrc] = useState(null);

  const [videoPlaying, setVideoPlaying] = useState(true);

  const videoPlayer = useRef();

  const playIcon = MediaService.getImage(
    '/Module1Images/Play-small_3x.png',
    login
  );

  const recordIcon = MediaService.getImage(
    '/Module1Images/Record-Small_3x.png',
    login
  );

  const getVideoData = useCallback(async () => {
    const videoData = await getVideo(video, login);
    setVideoSrc(videoData);
  }, [video]);

  useEffect(() => {
    getVideoData();
  }, [getVideoData]);

  const controlHandler = useCallback(() => {
    setVideoPlaying(!videoPlaying);
    videoPlaying ? videoPlayer.current.pause() : videoPlayer.current.play();
  }, [videoPlaying]);

  return (
    <div className='sing-video-player'>
      <main>
        {videoSrc && (
          <video autoPlay ref={videoPlayer} onEnded={onDemoEnded} playsInline>
            <source src={videoSrc} type='video/mp4'></source>
            Your browser does not support the video tag.
          </video>
        )}
        <div className='sing-video-controls'>
          <button onClick={() => controlHandler()}>
            <img alt='play pause' src={videoPlaying ? pauseButton : playIcon} />
          </button>
          <button onClick={onRecordClick}>
            <img alt='record' src={recordIcon} />
          </button>
        </div>
      </main>
    </div>
  );
};

export default SingVideoPlayer;
